// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__37ndJ","title":"Images90_title__2RqdY","images":"Images90_images__1LLXe"};